export default __webpack_public_path__ + "static/media/public.1b2252f7.svg";